import React, {FC} from 'react';

export interface WidgetTooltipProps {
    title?: string;
    children?: React.ReactNode;
}

const WidgetTooltip: FC<WidgetTooltipProps> = ({title, children}: WidgetTooltipProps) => {
    return (
        <>
            {!!title && (
                <>
                    <b>{title}</b>
                    <br />
                </>
            )}
            {children}
        </>
    );
};

export default WidgetTooltip;
